import { RootState } from 'typesafe-actions';

export const selectIsFavoritesShown = (state: RootState) =>
  state.ui.tripSettings.isFavoritesShown;

export const selectGlobalRouteOptions = (state: RootState) =>
  state.ui.tripSettings.routeOption;
